import {
  CommonHelperFunctions,
  IChatHistoryRequestDTO,
  IGenerateAgentRequestDTO,
  IOpenAICodeGeneratorReq,
  IOpenAICodeGeneratorRes,
  IOpenAICustomAITemplateModel,
  IOpenAIGenerateColumnRequestDTO,
  IOpenAIGenerateColumnResponseDTO,
  IOpenAIGenerateImagesWithAIDTO,
  IOpenAIGeneratedImagesDTO,
  IOpenAISqlGeneratorReq,
  OpenAIGenerateJsonFromImageRequestDTO,
  OpenAIUserInterfaceValidationRequestDTO,
  OpenAIUserInterfaceValidationResponseDTO
} from "@kuika/kuika-cl-model";
import { IOpenAIUserInterfaceValidationAnalysis } from "@kuika/kuika-cl-model/src/dtos/openai-user-interface-validation.dto";
import Axios, { AxiosResponse } from "axios";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class OpenAIService {
  public static GenerateColumnTypes(columnName: string) {
    return Axios.post<IOpenAIGenerateColumnRequestDTO, AxiosResponse<IOpenAIGenerateColumnResponseDTO>>(
      `${backendUrl}/openAi/generateColumnTypes`,
      { columnName }
    );
  }

  public static GenerateImage(payload: IOpenAIGenerateImagesWithAIDTO) {
    return Axios.post<IOpenAIGenerateImagesWithAIDTO, AxiosResponse<IOpenAIGeneratedImagesDTO>>(
      `${backendUrl}/openAi/generateImage`,
      payload
    );
  }

  public static GenerateCSharp(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateCSharp`,
      payload
    );
  }

  public static GenerateTypeScript(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateTypeScript`,
      payload
    );
  }

  public static GeneratePython(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generatePython`,
      payload
    );
  }

  public static GenerateJava(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateJava`,
      payload
    );
  }

  public static GenerateGo(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateGo`,
      payload
    );
  }

  public static GenerateRust(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateRust`,
      payload
    );
  }

  public static GenerateSql(payload: IOpenAISqlGeneratorReq) {
    return Axios.post<IOpenAISqlGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateSql`,
      payload
    );
  }

  public static GenerateJsonFromImage(payload: OpenAIGenerateJsonFromImageRequestDTO) {
    return Axios.post<OpenAIGenerateJsonFromImageRequestDTO, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/generateJsonFromImage`,
      payload
    );
  }

  public static UserInterfaceValidation(payload: OpenAIUserInterfaceValidationRequestDTO) {
    return Axios.post<OpenAIUserInterfaceValidationRequestDTO, AxiosResponse<OpenAIUserInterfaceValidationResponseDTO>>(
      `${backendUrl}/openAi/uiValidation`,
      payload
    );
  }

  public static UserInterfaceAnalysis(payload: OpenAIUserInterfaceValidationRequestDTO) {
    return Axios.post<OpenAIUserInterfaceValidationRequestDTO, AxiosResponse<IOpenAIUserInterfaceValidationAnalysis>>(
      `${backendUrl}/openAi/uiAnalysis`,
      payload
    );
  }

  public static UiAnalysisForScreen(payload: OpenAIUserInterfaceValidationRequestDTO) {
    return Axios.post<OpenAIUserInterfaceValidationRequestDTO, AxiosResponse<IOpenAIUserInterfaceValidationAnalysis>>(
      `${backendUrl}/openAi/uiAnalysisForScreen`,
      payload
    );
  }

  public static ChatBot(payload: IOpenAICodeGeneratorReq) {
    return Axios.post<IOpenAICodeGeneratorReq, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/chatbot`,
      payload
    );
  }

  public static GenerateCustomTemplate(payload: string) {
    return Axios.post<string, AxiosResponse<IOpenAICustomAITemplateModel>>(
      `${backendUrl}/openAi/generateCustomTemplate`,
      null,
      {
        params: { userPrompt: payload }
      }
    );
  }

  public static GenerateAgent(payload: IGenerateAgentRequestDTO) {
    return Axios.post<string, AxiosResponse<IOpenAICodeGeneratorRes>>(`${backendUrl}/openAi/generateAgent`, payload);
  }

  public static ChatGenerateAgent(payload: IGenerateAgentRequestDTO) {
    return Axios.post<string, AxiosResponse<IOpenAICodeGeneratorRes>>(
      `${backendUrl}/openAi/chatGenerateAgent`,
      payload
    );
  }

  public static ClearChatHistory(payload: IChatHistoryRequestDTO) {
    return Axios.post<string, AxiosResponse<string>>(`${backendUrl}/openAi/clearChatHistory`, payload);
  }
}
